var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('star-rating',{attrs:{"active-color":"#9637F1","inactive-color":"#DABDF7"},on:{"rating-selected":_vm.setRating},model:{value:(_vm.rating),callback:function ($$v) {_vm.rating=$$v},expression:"rating"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }